import { Badge, Button, Col, Divider, Input, Row } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import { FormattedMessage, useIntl } from "react-intl";
import filterimg from "../../assets/Filter_2.svg";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import { useIsMoblie } from "../../utils/hooks/useMobile";
import { COLORS } from "../../constants/Colors";
import Typography from "../Typography";

const SearchQueueCardWithFilter = (props) => {
  const { handleSerchShipment, onToggleFilter, filterDot, openCreateQueue } =
    props;
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const isMoblie = useIsMoblie();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px 8px 0px 0px",
        backgroundColor: "white",
        width: "100%",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <div className="py-3 px-4 d-flex align-items-center justify-content-between">
          <Typography className="py-3 px-0" isBold color={COLORS.Dark}>
            <FormattedMessage
              id="searchQueue"
              defaultMessage="ค้นหาคิวนำส่งสินค้า"
            />
          </Typography>
          <Button
            style={{
              backgroundColor: COLORS.GreenBrown,
              width: isDesktop ? null : "35px",
              padding: isDesktop ? null : "2px 5px",
              height: "35px",
              minWidth: isDesktop ? "97px" : undefined,
              borderRadius: "8px",
            }}
            type="primary"
            onClick={() => {
              openCreateQueue();
            }}
          >
            {isDesktop ? (
              <FormattedMessage
                id="btnAddQueueButton"
                defaultMessage="เพิ่มคิวใหม่"
              />
            ) : (
              <PlusOutlined />
            )}
          </Button>
        </div>
        <Divider className="m-0" />
        {/* <div
          className="py-3 px-4"
          style={{ display: "flex", justifyContent: "space-between" }}
        > */}
        <Row className="py-3 px-4" gutter={[16, 16]}>
          <Col xxl={21} xl={20} lg={19} md={20} sm={19} xs={19}>
            <Input
              allowClear
              style={{
                borderRadius: "20px",
                // width: isDesktop ? "85%" : "82%",
                width: "100%",
                marginRight: "5px",
                backgroundColor: "#F8F8F8",
                height: "35px",
                margintop: "5xp",
                border: "0px",
              }}
              placeholder={intl.formatMessage({
                id: "searchQueue",
                defaultMessage: "ค้นหาคิวนำส่งสินค้า",
              })}
              onChange={(e) => handleSerchShipment(e.target.value)}
              suffix={
                <div>
                  <SearchOutlined
                    style={{
                      color: "rgba(0,0,0,.45)",
                    }}
                  />
                </div>
              }
            />
          </Col>

          <Col style={{ paddingRight: '0px' }} xxl={3} xl={4} lg={5} md={4} sm={5} xs={5}>
            <div >
              <span
                style={{
                  display: 'flex',
                  backgroundColor: "#F8F8F8",
                  borderRadius: "20px",
                  padding: isDesktop ? "5px 22px" : "5px 15px",
                  cursor: "pointer",
                  textAlign: "center",
                  justifyContent: "center",
                  // width: isDesktop ? "auto" : "15%",
                  width: "100%",
                  minWidth: "auto",
                  // maxWidth: 'auto',
                  height: "35px",
                }}
                onClick={onToggleFilter}
              >
                <Badge dot={filterDot} status="processing">
                  <img src={filterimg} style={{ width: "20px" }} />
                </Badge>
                {isMoblie ? null : (
                  <span style={{ color: "#898989", marginLeft: "7px" }}>
                    <FormattedMessage
                      id="filterTracking"
                      defaultMessage="Filter"
                    />
                  </span>
                )}
              </span>
            </div>
          </Col>
        </Row>

        {/* </div> */}
      </div>
    </div>
  );
};

export default SearchQueueCardWithFilter;
